import React from 'react';
import { Button } from '../UI/Button';
interface CommunityAccessProps {
  userLocation?: string;
}
export const CommunityAccess = ({
  userLocation = ''
}: CommunityAccessProps) => {
  const communities = [{
    name: 'Lagos Community',
    emoji: '🌆',
    link: 'https://chat.whatsapp.com/BmhDckI1FiEJxVxNUXQbKh',
    locations: ['Lagos']
  }, {
    name: 'Abuja Community',
    emoji: '🏛️',
    link: 'https://chat.whatsapp.com/KyuLep5qjEwHU6VR8tiBW9',
    locations: ['Abuja']
  }, {
    name: 'Berlin Community',
    emoji: '🇩🇪',
    link: 'https://chat.whatsapp.com/BmhDckI1FiEJxVxNUXQbKh',
    locations: ['Berlin']
  }, {
    name: 'Houston Community',
    emoji: '🇺🇸',
    link: 'https://chat.whatsapp.com/KHjjcj7M9NsBfapdZKxIDZ',
    locations: ['Houston Texas']
  }, {
    name: 'Port Harcourt Community',
    emoji: '⚓',
    link: 'https://chat.whatsapp.com/JFzBdGe9gT92ljvUSRqvhE',
    locations: ['Port Harcourt']
  }, {
    name: 'Warri Community',
    emoji: '🔥',
    link: 'https://chat.whatsapp.com/H9pJfdO1GowB5bDvB0faDO',
    locations: ['Warri']
  }, {
    name: 'UK Community',
    emoji: '🇬🇧',
    link: 'https://chat.whatsapp.com/HOoTi54Z7jYLTsfZFArTlQ',
    locations: ['UK']
  }, {
    name: 'Benin City Community',
    emoji: '🏙️',
    link: 'https://chat.whatsapp.com/BmhDckI1FiEJxVxNUXQbKh',
    locations: ['Benin City']
  }];
  // Check if user's location matches any of our communities
  const matchingCommunity = communities.find(community => community.locations.includes(userLocation));
  const hasMatchingCommunity = !!matchingCommunity;
  const isOther = userLocation === 'Other';
  return <div className="bg-white p-6 rounded-lg border-2 border-gray-300" data-id="element-118" data-mp="29ehrim3logl1">
      <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-119" data-mp="24lwxpkkp23hi">
        Welcome to The Networking Salon Community!
      </h2>
      <p className="text-gray-700 mb-8" data-id="element-120" data-mp="1gvb0ypg545mt">
        The Networking Salon is designed to connect people to people, ideas, and
        opportunities. We are happy to have you join us in advancing this
        mission!
      </p>
      {hasMatchingCommunity ? <div className="mb-6" data-id="element-121" data-mp="3gyvgoig2zpzi">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-122" data-mp="3gxttjflsjd1f">
            Join the community in your city:
          </h3>
          <div className="space-y-4 border-2 border-dashed border-gray-300 p-6 rounded-lg" data-id="element-123" data-mp="3lq3qhflbpdd7">
            <div className="flex flex-col items-center text-center" data-id="element-124" data-mp="3ppvurg3ooxcr">
              <span className="text-3xl mb-3" data-id="element-125" data-mp="2t1oel1xhnb63">{matchingCommunity.emoji}</span>
              <h4 className="text-lg font-bold text-gray-800 mb-2" data-id="element-126" data-mp="2xzzkx2okr3jk">
                {matchingCommunity.name}
              </h4>
              <p className="text-gray-600 mb-4" data-id="element-127" data-mp="321befjakk8x1">
                Connect with like-minded professionals in your area.
              </p>
              <a href={matchingCommunity.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-128" data-mp="371z8kdu3h5vh">
                <span className="mr-2" data-id="element-129" data-mp="we420ujzclod">👋</span>
                Join Community
              </a>
            </div>
          </div>
        </div> : isOther ? <div className="mb-8 border-2 border-dashed border-gray-300 p-6 rounded-lg text-center" data-id="element-130" data-mp="rglrx0u880es">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-131" data-mp="mn9apbrvmvw2">
            Thank you for joining our community!
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-132" data-mp="ikw8gxcc9g41">
            We're thrilled to connect with you as the first member from your
            area! There's so much we want to share with you and explore how we
            can bring The Networking Salon to your city.
          </p>
          <p className="text-gray-700 mb-6" data-id="element-133" data-mp="3q86vua271tp">
            Click the button below to get in touch with us directly.
          </p>
          <div className="flex justify-center" data-id="element-134" data-mp="3vvlfg7w9d6w3">
            <a href="https://wa.link/plqr43" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-135" data-mp="1y40o69yjjvc9">
              <span className="mr-2" data-id="element-136" data-mp="216566ek1rth2">📱</span>
              Let's Chat on WhatsApp!
            </a>
          </div>
        </div> : <div className="mb-8 border-2 border-dashed border-gray-300 p-6 rounded-lg text-center" data-id="element-137" data-mp="2622ogqevf9wh">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-138" data-mp="1s70819cee25f">
            We couldn't find a matching community
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-139" data-mp="1iecdymcsycae">
            It seems we don't have a community in your location yet. We'd love
            to help you connect with our global network or explore starting a
            community in your area.
          </p>
          <p className="text-gray-700 mb-6" data-id="element-140" data-mp="18ihob7a5vgy4">
            Click the button below to get in touch with us directly.
          </p>
          <div className="flex justify-center" data-id="element-141" data-mp="zg07j8d9zgii">
            <a href="https://wa.link/plqr43" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-142" data-mp="zhbax72t6m93">
              <span className="mr-2" data-id="element-143" data-mp="kv4dwjltbjj2">📱</span>
              Let's Chat on WhatsApp!
            </a>
          </div>
        </div>}
      <div className="bg-gray-100 p-4 rounded-lg" data-id="element-144" data-mp="tuhe0lo1qvr4">
        <p className="text-gray-700 font-medium" data-id="element-145" data-mp="tvaqm39osfh6">
          Remember to actively engage, share opportunities, and support other
          members. Together, we can build a thriving community that benefits
          everyone!
        </p>
      </div>
    </div>;
};